import { MenuDetailsFragment } from '@/graphql';
import { Link } from '@/i18n/navigation';
import { SlArrowDown } from 'react-icons/sl';
import Skeleton from 'react-loading-skeleton';
import { Accordion } from 'rsuite';
import styles from './footerMobile.module.scss';

const Header = (props: { title: any }) => {
  const { title } = props;
  return (
    <div className={styles.headerContent}>
      <h4>{title}</h4>
    </div>
  );
};

const FooterMobileContent = ({
  menu,
  loading,
}: {
  menu: MenuDetailsFragment | null | undefined;
  loading: boolean;
}) => {
  return (
    <div className={styles.accordion}>
      <Accordion defaultActiveKey={1}>
        {loading
          ? Array.from({ length: 3 }).map((_, index) => (
              <div key={index} className={styles.skeletonForMobile}>
                <Skeleton />
              </div>
            ))
          : menu?.items?.map((i, id) => (
              <Accordion.Panel
                key={id + '_' + i.name}
                header={<Header title={i.name} />}
                caretAs={SlArrowDown}
                eventKey={id}
              >
                <div className={styles.accordion__section}>
                  {i.children?.map((c, cid) => (
                    <Link
                      key={cid}
                      href={c.url || '#'}
                      className={styles.accordion__link}
                    >
                      {c.name}
                    </Link>
                  ))}
                </div>
              </Accordion.Panel>
            ))}
      </Accordion>
    </div>
  );
};

export default FooterMobileContent;
